import React, { useEffect, useState } from "react";
import backarrow from "../../Assets/svg/backarrow.svg";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Container, Row, Col, Spinner } from "react-bootstrap";
import MultiSelectDropDown from "../common/searchbox/multi-select-dropdown.js";
import SearchWithAPI from "../common/searchbox/searchbox.js";
import CommonAsyncSelect from "../common/common-async-select.jsx";

import "./vendor.css";
import { getApi, postApi, putApi } from "../common/api-client.js";

const Vendoradd = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const adminUrl = process.env.REACT_APP_ADMIN_API_URL;
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = location.state || {};

  const [code, setCode] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [address, setAddress] = useState("");
  const [zipcode, setZipCode] = useState("");
  const [isSaving, setIsSaving] = useState(false);

  const [selectedProjectOptions, setSelectedProjectOptions] = useState([]);
  const [selecteduserList, setSelectedUserList] = useState([]);
  const [selectedAppList, setSelectedAppList] = useState([]);

  const [cityId, setCityId] = useState(null);
  const [stateId, setStateId] = useState(null);
  const [countryId, setCountryId] = useState(null);

  const [validations, setValidations] = useState({
    code: "",
    name: "",
    email: "",
    phonenumber: "",
    projects: "",
    applications: "",
    emps: "",
    city_id: "",
    state_id: "",
    country_id: "",
    zipcode: "",
  });

  const handleProjectDropdownChange = (option) => {
    const exists = selectedProjectOptions.find((o) => o.value === option.value);
    if (exists) {
      setSelectedProjectOptions(
        selectedProjectOptions.filter((o) => o.value !== option.value)
      );
    } else {
      setSelectedProjectOptions([...selectedProjectOptions, option]);
    }
  };

  const vendorSave = async () => {
    if (isSaving) return;

    setValidations({
      code: "",
      name: "",
      email: "",
      phonenumber: "",
      applications: "",
      projects: "",
      emps: "",
      city_id: "",
      state_id: "",
      country_id: "",
      zipcode: "",
    });

    const payload = {
      code,
      name,
      email,
      phonenumber: phoneNumber,
      projects: selectedProjectOptions.map((i) => i.value),
      emps: selecteduserList.map((i) => i.value),
      applications: selectedAppList.map((i) => i.value),
      address,
      city_id: cityId?.value || 0,
      state_id: stateId?.value || 0,
      country_id: countryId?.value || 0,
      zipcode,
    };

    try {
      setIsSaving(true);

      const res = id
        ? await putApi(`${apiUrl}vendor/${id}`, payload)
        : await postApi(`${apiUrl}/vendor`, payload);

      if (res.success) navigate(-1);
    } catch (err) {
      if (err.response?.data?.error) {
        const temp = { ...validations };
        Object.entries(err.response.data.error).forEach(
          ([k, v]) => (temp[k] = v[0])
        );
        setValidations(temp);
      }
    } finally {
      setIsSaving(false);
    }
  };

  const vendorEdit = async () => {
    const res = await getApi(`${apiUrl}vendor/${id}`);

    if (res.success) {
      const v = res.vendor;
      setCode(v.code ?? "");
      setName(v.name ?? "");
      setEmail(v.email ?? "");
      setPhoneNumber(v.phonenumber ?? "");
      setAddress(v.address ?? "");
      setZipCode(v.zipcode ?? "");

      setCityId({ value: v.city_id, label: v.city });
      setStateId({ value: v.state_id, label: v.state });
      setCountryId({ value: v.country_id, label: v.country });

      setSelectedProjectOptions(v.projects ?? []);
      setSelectedUserList(v.emps ?? []);
      setSelectedAppList(v.applications ?? []);
    }
  };

  useEffect(() => {
    if (id) vendorEdit();
  }, [id]);

  return (
    <Container fluid className="vendor-add-container">
      <Row className="vendor-row">
        <Col>
          <div className="vendor-add-wrapper">
            <div className="vendor-add-bg">
              <div className="vendor-add-header">
                <div className="vendor-add-header-left">
                  <Link to="/vendor/list">
                    <img src={backarrow} alt="back" />
                  </Link>
                  <span className="vendor-add-title">New Vendor</span>
                </div>

                <div className="vendor-add-flex vendor-add-gap-12">
                  <div
                    className="vendor-add-btn-cancel"
                    onClick={() => navigate(-1)}
                  >
                    Cancel
                  </div>
                  <div
                    className={`vendor-add-btn-save ${
                      isSaving ? "disabled" : ""
                    }`}
                    onClick={vendorSave}
                  >
                    {isSaving ? (
                      <Spinner
                        animation="border"
                        size="sm"
                        role="status"
                        className="text-white"
                      />
                    ) : (
                      "Save"
                    )}
                  </div>
                </div>
              </div>

              <div className="vendor-add-card">
                <div className="vendor-add-section-title">Add Vendor</div>
                <div className="vendor-add-section-subtitle">
                  Enter below details to create new vendor
                </div>

                <div className="vendor-add-row mt-3">
                  <div className="vendor-add-col col-5">
                    <label className="vendor-add-label">
                      Code <span className="vendor-add-required">*</span>
                    </label>
                    <input
                      className="vendor-add-input"
                      placeholder="Enter code"
                      value={code}
                      onChange={(e) => setCode(e.target.value)}
                    />
                    <div className="vendor-add-error">{validations.code}</div>
                  </div>

                  <div className="vendor-add-col col-5">
                    <label className="vendor-add-label">
                      Vendor name <span className="vendor-add-required">*</span>
                    </label>
                    <input
                      className="vendor-add-input"
                      placeholder="Enter name"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                    />
                    <div className="vendor-add-error">{validations.name}</div>
                  </div>
                </div>

                <div className="vendor-add-row">
                  <div className="vendor-add-col col-5">
                    <label className="vendor-add-label">Phone number</label>
                    <input
                      className="vendor-add-input"
                      placeholder="Enter number"
                      value={phoneNumber}
                      onChange={(e) => {
                        const val = e.target.value;
                        if (/^[0-9\s\-()+]*$/.test(val)) {
                          setPhoneNumber(val);
                        }
                      }}
                    />
                    <div className="vendor-add-error">
                      {validations.phonenumber}
                    </div>
                  </div>

                  <div className="vendor-add-col col-5">
                    <label className="vendor-add-label">Email</label>
                    <input
                      className="vendor-add-input"
                      placeholder="Enter email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                    <div className="vendor-add-error">{validations.email}</div>
                  </div>
                </div>

                <div className="vendor-add-row">
                  <div className="vendor-add-col col-5">
                    <label className="vendor-add-label">Project</label>
                    <MultiSelectDropDown
                      onDropdownChange={handleProjectDropdownChange}
                      apiUrl={"get_project"}
                      selectedOption={selectedProjectOptions}
                      placeholder={"Select project"}
                    />
                    <div className="vendor-add-error">
                      {validations.projects}
                    </div>
                  </div>

                  <div className="vendor-add-col col-5">
                    <label className="vendor-add-label">Users</label>
                    <CommonAsyncSelect
                      isMulti
                      value={selecteduserList}
                      onChange={setSelectedUserList}
                      apiUrl={adminUrl + "get_employee"}
                      queryKey="term"
                    />
                    <div className="vendor-add-error">{validations.emps}</div>
                  </div>
                </div>

       
                <div className="vendor-add-address-title mt-3">
                  Address info
                </div>

                <div style={{ width: "50%" }}>
                  <div className="vendor-add-col">
                    <label className="vendor-add-label">Address</label>
                    <input
                      className="vendor-add-input"
                      placeholder="Enter address"
                      value={address}
                      onChange={(e) => setAddress(e.target.value)}
                    />
                  </div>

                  <div className="vendor-add-grid">
                    <div className="vendor-add-col">
                      <label className="vendor-add-label">City</label>
                      <SearchWithAPI
                        apiUrl={adminUrl + "get_city"}
                        placeholder="City"
                        selectedOption={cityId}
                        onDropdownChange={(o) => {
                          setCityId(o);
                          setStateId({
                            value: o.state_id,
                            label: o.state_name,
                          });
                          setCountryId({
                            value: o.country_id,
                            label: o.country_name,
                          });
                        }}
                      />
                      <div className="vendor-add-error">
                        {validations.city_id}
                      </div>
                    </div>

                    <div className="vendor-add-col">
                      <label className="vendor-add-label">State</label>
                      <SearchWithAPI
                        apiUrl={adminUrl + "get_state"}
                        placeholder="State"
                        selectedOption={stateId}
                        onDropdownChange={setStateId}
                      />
                      <div className="vendor-add-error">
                        {validations.state_id}
                      </div>
                    </div>
                  </div>

                  <div className="vendor-add-grid">
                    <div className="vendor-add-col">
                      <label className="vendor-add-label">Country</label>
                      <SearchWithAPI
                        apiUrl={adminUrl + "get_country"}
                        placeholder="Country"
                        selectedOption={countryId}
                        onDropdownChange={setCountryId}
                      />
                      <div className="vendor-add-error">
                        {validations.country_id}
                      </div>
                    </div>

                    <div className="vendor-add-col">
                      <label className="vendor-add-label">Zip code</label>
                      <input
                        className="vendor-add-input"
                        placeholder="Enter zip code"
                        value={zipcode}
                        onChange={(e) => setZipCode(e.target.value)}
                      />
                      <div className="vendor-add-error">
                        {validations.zipcode}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Vendoradd;
